import classNames from 'classnames';
import {
  getCornerStyleClassname,
  getIntensityClassName,
  getOpacityBlurClassName,
  getOpacityClassName,
  IntensityLevel,
  OpacityLevel,
  Size,
} from '../../../constants';
import { useTheme } from '../../../context/theme/useTheme';

export const IntensityWrapper = (props: Props) => {
  const { intensity, cardCornerStyle, opacity, opacityBlur, className } = props;
  const { isDarkMode } = useTheme();

  return (
    <div
      className={classNames(
        className,
        getIntensityClassName({ intensity, isDarkMode }),
        getCornerStyleClassname(cardCornerStyle),
        getOpacityClassName(opacity),
        getOpacityBlurClassName(opacityBlur),
        'absolute z-[1] h-full w-full'
      )}
    />
  );
};

type Props = {
  intensity?: IntensityLevel;
  cardCornerStyle?: Size;
  opacity?: OpacityLevel;
  opacityBlur?: Size;
  className?: string;
};
